import React, {useState} from "react"
import {Row, Col, Divider} from "antd"
import {KlassDropdown} from "components/Select"
import {BaseRangePicker} from "components/DateTimePicker"
import {BaseFilter} from "uiKit"
import {useTranslation} from "react-i18next"
import {Search} from "components/inputs/Search"
import styles from "./Filters.module.css"

const Filters = (props) => {
    const {t} = useTranslation(["common"])
    const [search, setSearch] = useState("")

    return (
        <BaseFilter isShowFilterClear>
            <Row gutter={[40, 32]}>
                <Col span={12}>
                    <KlassDropdown options={[]} value={[]} placeholder="Type" />
                </Col>
                <Col span={12}>
                    <BaseRangePicker placeholder={["Last Updated", "End Date"]} value="" />
                </Col>
                <Col span={12}>
                    <KlassDropdown options={[]} value={[]} placeholder="Status" />
                </Col>
                <Divider className={styles.divider} />
                <Col span={24}>
                    <Search
                        value={search}
                        onChange={setSearch}
                        onPressEnter={() => {}}
                        placeholder={t("common:action.search")}
                    />
                </Col>
            </Row>
        </BaseFilter>
    )
}

export default Filters
